import 'css-chunk:../../src/components/form/form-password/index.module.scss';export default {
  "wrapper": "_wrapper_gjvsz_1",
  "input": "_input_gjvsz_15",
  "outlined": "_outlined_gjvsz_24",
  "disabled": "_disabled_gjvsz_42"
};